module.exports = __webpack_public_path__ + "img/card-contract-editor-hover.f16a7220.svg";